interface Props {
  index: number;
  className?: string;
  width?: string;
  height?: string;
}

const DummyAvatar = ({ index, className, width, height }: Props) => {
  switch (index % 5) {
    case 0:
      return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          width={width}
          height={height}
          fill="none"
          viewBox="0 0 32 32"
        >
          <g clipPath="url(#clip0_3416_53516)">
            <g filter="url(#filter0_dd_3416_53516)">
              <circle cx="16" cy="16" r="16" fill="#F7F5FF" />
            </g>
            <g filter="url(#filter1_f_3416_53516)" opacity=".8">
              <ellipse
                cx="15.813"
                cy="15.617"
                fill="#F092DD"
                rx="15.813"
                ry="15.617"
                transform="matrix(-.2882 -.95757 .93652 -.35062 5.539 27.096)"
              />
            </g>
            <g filter="url(#filter2_f_3416_53516)" opacity=".8">
              <ellipse
                cx="13.418"
                cy="12.998"
                fill="#3843D0"
                rx="13.418"
                ry="12.998"
                transform="matrix(-.48289 -.87568 .7985 -.602 3.784 29.613)"
              />
            </g>
            <g filter="url(#filter3_f_3416_53516)" opacity=".8">
              <path
                fill="#F092DD"
                d="M31.53-6.674c7.112 5.816 1.695 35.104-1.055 33.18-1.678-1.175-3.661-11.107-8.928-15.363-3.367-2.721-9.395-.736-13.235-.455-9.845.72 16.046-23.227 23.218-17.362Z"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_dd_3416_53516"
              width="56"
              height="56"
              x="-12"
              y="-10"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="6" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix values="0 0 0 0 0.6875 0 0 0 0 0.744318 0 0 0 0 1 0 0 0 0.06 0" />
              <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3416_53516" />
              <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix values="0 0 0 0 0.549757 0 0 0 0 0.610463 0 0 0 0 0.929167 0 0 0 0.05 0" />
              <feBlend in2="effect1_dropShadow_3416_53516" result="effect2_dropShadow_3416_53516" />
              <feBlend in="SourceGraphic" in2="effect2_dropShadow_3416_53516" result="shape" />
            </filter>
            <filter
              id="filter1_f_3416_53516"
              width="54.646"
              height="56.212"
              x="-11.716"
              y="-21.628"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur result="effect1_foregroundBlur_3416_53516" stdDeviation="6" />
            </filter>
            <filter
              id="filter2_f_3416_53516"
              width="48.473"
              height="52.237"
              x="-16.554"
              y="-16.079"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur result="effect1_foregroundBlur_3416_53516" stdDeviation="6" />
            </filter>
            <filter
              id="filter3_f_3416_53516"
              width="52.942"
              height="58.196"
              x="-5.893"
              y="-19.6"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur result="effect1_foregroundBlur_3416_53516" stdDeviation="6" />
            </filter>
            <clipPath id="clip0_3416_53516">
              <rect width="32" height="32" fill="#fff" rx="16" />
            </clipPath>
          </defs>
        </svg>
      );
    case 1:
      return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          width={width}
          height={height}
          fill="none"
          viewBox="0 0 32 32"
        >
          <g clip-path="url(#clip0_3416_53523)">
            <g filter="url(#filter0_dd_3416_53523)">
              <circle cx="16" cy="16" r="16" fill="#F7F5FF" />
            </g>
            <g filter="url(#filter1_f_3416_53523)" opacity=".8">
              <ellipse
                cx="15.813"
                cy="15.617"
                fill="#FFC8EB"
                rx="15.813"
                ry="15.617"
                transform="matrix(-.2882 -.95757 .93652 -.35062 5.539 27.096)"
              />
            </g>
            <g filter="url(#filter2_f_3416_53523)" opacity=".8">
              <ellipse
                cx="13.418"
                cy="12.998"
                fill="#888EE3"
                rx="13.418"
                ry="12.998"
                transform="matrix(-.48289 -.87568 .7985 -.602 3.784 29.613)"
              />
            </g>
            <g filter="url(#filter3_f_3416_53523)" opacity=".8">
              <path
                fill="#888EE3"
                d="M31.53-6.674c7.112 5.816 1.695 35.104-1.055 33.18-1.678-1.175-3.661-11.107-8.928-15.363-3.367-2.721-9.395-.736-13.235-.455-9.845.72 16.046-23.227 23.218-17.362Z"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_dd_3416_53523"
              width="56"
              height="56"
              x="-12"
              y="-10"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="6" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix values="0 0 0 0 0.6875 0 0 0 0 0.744318 0 0 0 0 1 0 0 0 0.06 0" />
              <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3416_53523" />
              <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix values="0 0 0 0 0.549757 0 0 0 0 0.610463 0 0 0 0 0.929167 0 0 0 0.05 0" />
              <feBlend in2="effect1_dropShadow_3416_53523" result="effect2_dropShadow_3416_53523" />
              <feBlend in="SourceGraphic" in2="effect2_dropShadow_3416_53523" result="shape" />
            </filter>
            <filter
              id="filter1_f_3416_53523"
              width="54.646"
              height="56.212"
              x="-11.716"
              y="-21.628"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur result="effect1_foregroundBlur_3416_53523" stdDeviation="6" />
            </filter>
            <filter
              id="filter2_f_3416_53523"
              width="48.473"
              height="52.237"
              x="-16.554"
              y="-16.079"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur result="effect1_foregroundBlur_3416_53523" stdDeviation="6" />
            </filter>
            <filter
              id="filter3_f_3416_53523"
              width="52.942"
              height="58.196"
              x="-5.893"
              y="-19.6"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur result="effect1_foregroundBlur_3416_53523" stdDeviation="6" />
            </filter>
            <clipPath id="clip0_3416_53523">
              <rect width="32" height="32" fill="#fff" rx="16" />
            </clipPath>
          </defs>
        </svg>
      );
    case 2:
      return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          width={width}
          height={height}
          viewBox="0 0 32 32"
          fill="none"
        >
          <g clip-path="url(#clip0_3416_53530)">
            <g filter="url(#filter0_dd_3416_53530)">
              <circle cx="16" cy="16" r="16" fill="#F7F5FF" />
            </g>
            <g opacity="0.8" filter="url(#filter1_f_3416_53530)">
              <ellipse
                cx="15.8131"
                cy="15.6167"
                rx="15.8131"
                ry="15.6167"
                transform="matrix(-0.288205 -0.957569 0.936518 -0.35062 5.539 27.0959)"
                fill="#D7D9F6"
              />
            </g>
            <g opacity="0.8" filter="url(#filter2_f_3416_53530)">
              <ellipse
                cx="13.4181"
                cy="12.9975"
                rx="13.4181"
                ry="12.9975"
                transform="matrix(-0.482888 -0.875682 0.798496 -0.602 3.78387 29.6135)"
                fill="#888EE3"
              />
            </g>
            <g opacity="0.8" filter="url(#filter3_f_3416_53530)">
              <path
                d="M31.5297 -6.67435C38.6418 -0.857747 33.2253 28.4297 30.4749 26.5051C28.7972 25.331 26.8136 15.3991 21.5466 11.1429C18.1796 8.42202 12.1516 10.4074 8.31222 10.6882C-1.53304 11.4082 24.3582 -12.5395 31.5297 -6.67435Z"
                fill="#060419"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_dd_3416_53530"
              x="-12"
              y="-10"
              width="56"
              height="56"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="6" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.6875 0 0 0 0 0.744318 0 0 0 0 1 0 0 0 0.06 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3416_53530" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.549757 0 0 0 0 0.610463 0 0 0 0 0.929167 0 0 0 0.05 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_3416_53530" result="effect2_dropShadow_3416_53530" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3416_53530" result="shape" />
            </filter>
            <filter
              id="filter1_f_3416_53530"
              x="-11.7161"
              y="-21.6277"
              width="54.6461"
              height="56.2122"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_3416_53530" />
            </filter>
            <filter
              id="filter2_f_3416_53530"
              x="-16.5538"
              y="-16.0793"
              width="48.4734"
              height="52.2368"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_3416_53530" />
            </filter>
            <filter
              id="filter3_f_3416_53530"
              x="-5.89307"
              y="-19.6001"
              width="52.942"
              height="58.1958"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_3416_53530" />
            </filter>
            <clipPath id="clip0_3416_53530">
              <rect width="32" height="32" rx="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 3:
      return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          width={width}
          height={height}
          viewBox="0 0 32 32"
          fill="none"
        >
          <g clip-path="url(#clip0_3416_53537)">
            <g filter="url(#filter0_dd_3416_53537)">
              <circle cx="16" cy="16" r="16" fill="#F7F5FF" />
            </g>
            <g opacity="0.8" filter="url(#filter1_f_3416_53537)">
              <ellipse
                cx="15.8131"
                cy="15.6167"
                rx="15.8131"
                ry="15.6167"
                transform="matrix(-0.288205 -0.957569 0.936518 -0.35062 5.539 27.0959)"
                fill="#3843D0"
              />
            </g>
            <g opacity="0.8" filter="url(#filter2_f_3416_53537)">
              <ellipse
                cx="13.4181"
                cy="12.9975"
                rx="13.4181"
                ry="12.9975"
                transform="matrix(-0.482888 -0.875682 0.798496 -0.602 3.78387 29.6135)"
                fill="#3843D0"
              />
            </g>
            <g opacity="0.8" filter="url(#filter3_f_3416_53537)">
              <path
                d="M31.5297 -6.67435C38.6418 -0.857747 33.2253 28.4297 30.4749 26.5051C28.7972 25.331 26.8136 15.3991 21.5466 11.1429C18.1796 8.42202 12.1516 10.4074 8.31222 10.6882C-1.53304 11.4082 24.3582 -12.5395 31.5297 -6.67435Z"
                fill="#FF5EC4"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_dd_3416_53537"
              x="-12"
              y="-10"
              width="56"
              height="56"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="6" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.6875 0 0 0 0 0.744318 0 0 0 0 1 0 0 0 0.06 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3416_53537" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.549757 0 0 0 0 0.610463 0 0 0 0 0.929167 0 0 0 0.05 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_3416_53537" result="effect2_dropShadow_3416_53537" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3416_53537" result="shape" />
            </filter>
            <filter
              id="filter1_f_3416_53537"
              x="-11.7161"
              y="-21.6277"
              width="54.6461"
              height="56.2122"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_3416_53537" />
            </filter>
            <filter
              id="filter2_f_3416_53537"
              x="-16.5538"
              y="-16.0793"
              width="48.4734"
              height="52.2368"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_3416_53537" />
            </filter>
            <filter
              id="filter3_f_3416_53537"
              x="-5.89307"
              y="-19.6001"
              width="52.942"
              height="58.1958"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_3416_53537" />
            </filter>
            <clipPath id="clip0_3416_53537">
              <rect width="32" height="32" rx="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 4:
      return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          width={width}
          height={height}
          viewBox="0 0 32 32"
          fill="none"
        >
          <g clip-path="url(#clip0_3416_53544)">
            <g filter="url(#filter0_dd_3416_53544)">
              <circle cx="16" cy="16" r="16" fill="#F8F8F8" />
            </g>
            <g opacity="0.8" filter="url(#filter1_f_3416_53544)">
              <ellipse
                cx="15.8131"
                cy="15.6167"
                rx="15.8131"
                ry="15.6167"
                transform="matrix(-0.288205 -0.957569 0.936518 -0.35062 5.539 27.0959)"
                fill="#9D9EAA"
              />
            </g>
            <g opacity="0.8" filter="url(#filter2_f_3416_53544)">
              <ellipse
                cx="13.4181"
                cy="12.9975"
                rx="13.4181"
                ry="12.9975"
                transform="matrix(-0.482888 -0.875682 0.798496 -0.602 3.78387 29.6135)"
                fill="#9D9EAA"
              />
            </g>
            <g opacity="0.8" filter="url(#filter3_f_3416_53544)">
              <path
                d="M31.5297 -6.67435C38.6418 -0.857747 33.2253 28.4297 30.4749 26.5051C28.7972 25.331 26.8136 15.3991 21.5466 11.1429C18.1796 8.42202 12.1516 10.4074 8.31222 10.6882C-1.53304 11.4082 24.3582 -12.5395 31.5297 -6.67435Z"
                fill="#CECFD4"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_dd_3416_53544"
              x="-12"
              y="-10"
              width="56"
              height="56"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="6" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.6875 0 0 0 0 0.744318 0 0 0 0 1 0 0 0 0.06 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3416_53544" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.549757 0 0 0 0 0.610463 0 0 0 0 0.929167 0 0 0 0.05 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_3416_53544" result="effect2_dropShadow_3416_53544" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3416_53544" result="shape" />
            </filter>
            <filter
              id="filter1_f_3416_53544"
              x="-11.7161"
              y="-21.6277"
              width="54.6461"
              height="56.2122"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_3416_53544" />
            </filter>
            <filter
              id="filter2_f_3416_53544"
              x="-16.5538"
              y="-16.0793"
              width="48.4734"
              height="52.2368"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_3416_53544" />
            </filter>
            <filter
              id="filter3_f_3416_53544"
              x="-5.89307"
              y="-19.6001"
              width="52.942"
              height="58.1958"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_3416_53544" />
            </filter>
            <clipPath id="clip0_3416_53544">
              <rect width="32" height="32" rx="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    default:
      return null;
  }
};

export { DummyAvatar };
